<style  scoped="scoped">
@import '../../../../assets/css/common.css';
</style>
<style scoped="scoped">
	.mobileEgcode {
		color: #333333;
		font-family:"SourceHanSansCN-Regular";
		font-size: 12px;
	}
</style>
<style type="text/css">
	.mobileEgcode .el-menu-item{
		height: 45px;
		line-height: 45px;
		border-bottom: 1px solid #2F3757;
	}

  .mobileEgcode .dev_title{
    padding: 20px 0 0;
    font-size: 16px;
		letter-spacing: 1px;
		font-weight: 600;
		text-align: center;
  }
  .mobileEgcode .dev_title span {
    margin-left: 23px;
	}
  .mobileEgcode .content-wrapper .code{
    margin: 20px auto;
    width:90%;
    height:2900px;
    border-radius:4px;
  }
  .mobileEgcode .content-wrapper .CodeMirror.cm-s-darcula{
		height: 2900px;
		width: 100%;
    border: 1px solid #EBEBEB;
    background-color: #F7F7F7;
    color:#666666;
  }

  .mobileEgcode  .cm-s-darcula.CodeMirror{
    background-color: #F7F7F7;
  }
  .mobileEgcode  .CodeMirror-linenumber{
    color:#666666;
  }
  .mobileEgcode  .CodeMirror-linenumber.CodeMirror-gutter-elt,
  .mobileEgcode .CodeMirror-gutter.CodeMirror-linenumbers{
    background-color: #F7F7F7;
  }
  .mobileEgcode .CodeMirror-gutters{
    border-color: #F7F7F7 ;
    margin-right: 18px;
    border-right: 1px solid #F7F7F7!important;
  }
  .mobileEgcode .cm-s-darcula span.cm-variable {
    color:#666666!important;
  }
  .mobileEgcode .CodeMirror-activeline{
    background-color: #ffffff;
  }
  .mobileEgcode .CodeMirror-activeline .CodeMirror-line{
    /*background-color: #ffffff;*/
    background-color: #F7F7F7;
  }
  .mobileEgcode .el-button--text{
    color: #108EE9;
  }
  .mobileEgcode .el-button{
    padding: 6px 0;
  }
  .mobileEgcode .el-container .el-menu{
    border-right: none;
  }
</style>
<template>
  <div class="mobileEgcode">
    <header class="mobilehead">
      <el-row>
        <el-col :span="4"><div style="padding-left:8px" @click="clickLogin"><img src="../../../../assets/images/icon/back.png" /></div></el-col>
        <el-col :span="16"><div class="tlc">示例代码</div></el-col>
        <el-col :span="4">
          <div @click="menulist = !menulist">
            <img src="../../../../assets/images/icon/mobilemenu.png" v-if="!menulist"/>
            <img src="../../../../assets/images/icon/mobileclose.png" v-if="menulist"/>
          </div>
        </el-col>
      </el-row>
    </header>
    <div class="menulist" v-if="menulist" @touchmove.prevent>
      <el-menu
        :default-active="defaultActive"
        @select="selectMenu"
        background-color="#20263B"
        text-color="#D3D3D5"
        active-text-color="#108EE9"
        class="example-menu">
        <el-menu-item index="1">JAVA调用示例</el-menu-item>
        <!-- <el-menu-item index="2">PHP调用示例</el-menu-item>
        <el-menu-item index="3">.NET调用示例</el-menu-item>
        <el-menu-item index="4">PYTHON调用示例</el-menu-item> -->
      </el-menu>
    </div>
    <div v-if="menulist" @click="menulist = !menulist" class="menulist-mask" @touchmove.prevent></div>
    <el-main class="content-wrapper" style="background:white;">
      <div class="dev_title">
        {{titles[defaultActive-1]}}
      </div>
      <div class="code" style="position:relative;">
        <!-- <div style="position:absolute;right: 35px; z-index: 10; top:10px;">
            <el-button type="text" @click="copyCode">复制</el-button>
        </div> -->
        <codemirror v-if="defaultActive==='1'" v-model="code1" :options="cmOption1"></codemirror>
        <codemirror v-if="defaultActive==='2'" v-model="code2" :options="cmOption2"></codemirror>
        <codemirror v-if="defaultActive==='3'" v-model="code3" :options="cmOption3"></codemirror>
        <codemirror v-if="defaultActive==='4'" v-model="code4" :options="cmOption4"></codemirror>
      </div>
      <pre id="content" v-show="false">
        {{ content }}
      </pre>
    </el-main>
    <div id="toTop" class="toTop" v-show="isShow" @click="toTop()"></div>
  </div>
</template>

<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/mode/go/go.js'
import 'codemirror/mode/php/php.js'
import 'codemirror/mode/vb/vb.js'
import 'codemirror/mode/python/python.js'
import 'codemirror/theme/darcula.css'
import 'codemirror/addon/selection/active-line.js'
import {JAVA_CODE, PHP_CODE, NET_CODE, PYTHON_CODE} from '@/utils/code'

export default {
  name: 'mobileEgcode',
  components: {
    codemirror
  },
  data: function () {
    return {
      codes: [JAVA_CODE, PHP_CODE, NET_CODE, PYTHON_CODE],
      code1: JAVA_CODE,
      code2: PHP_CODE,
      code3: NET_CODE,
      code4: PYTHON_CODE,
      content: JAVA_CODE,
      models: ['text/x-vb', 'application/x-httpd-php', 'text/x-vb', 'text/x-vb'],
      // titles: ['JAVA调用示例', 'PHP调用示例', '.NET调用示例', 'PYTHON调用示例'],
      titles: ['JAVA调用示例'],
      defaultActive: '1',
      cmOption1: {
        tabSize: 4,
        readOnly: 'nocursor',
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'text/x-go',
        lineWrapping: true,
        theme: 'darcula'
      },
      cmOption2: {
        tabSize: 4,
        readOnly: 'nocursor',
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'application/x-httpd-php',
        lineWrapping: true,
        theme: 'darcula'
      },
      cmOption3: {
        tabSize: 4,
        readOnly: 'nocursor',
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'text/x-vb',
        lineWrapping: true,
        theme: 'darcula'
      },
      cmOption4: {
        tabSize: 4,
        readOnly: 'nocursor',
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        mode: 'python',
        lineWrapping: true,
        theme: 'darcula'
      },
      menulist: false,
      isShow: false
    }
  },

  async mounted () {
  },
  methods: {
    clickLogin () {
      this.pagedefault = ''
      this.$router.push({name: 'fronthome'})
      this.$nextTick(() => {
        this.pagedefault = '/'
      })
    },
    selectMenu (index, indexPath) {
      this.defaultActive = index
      this.content = this.codes[this.defaultActive - 1]
      this.menulist = false
    },
    copyCode () {
      const range = document.createRange()
      range.selectNode(document.getElementById('content'))
      const selection = window.getSelection()
      if (selection.rangeCount > 0) selection.removeAllRanges()
      selection.addRange(range)
      document.execCommand('copy')
    },
    // 屏幕滚动
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 300) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },
    toTop () {
      let distanceY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let i = 0
      this.interval = setInterval(() => {
        if (distanceY - 60 > 0) {
          distanceY -= 60
          window.scrollTo(0, distanceY)
        } else {
          window.scrollTo(0, 0)
          clearInterval(this.interval)
        }
      }, 10)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/front/mobile-page/mobileegcode/index.vue